import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

import type { Validate } from './types/validation';

const getStringLength = (val: number | string | undefined) =>
  val == null ? 0 : String(val).trim().length;

export const minLength = (val: string | undefined, min: number | string) =>
  getStringLength(val) < Number(min);

export const maxLength = (val: string | undefined, max: number) => getStringLength(val) > max;

export const isRequired = (val: string | number | boolean | undefined) =>
  typeof val === 'boolean' ? !val : getStringLength(val) === 0;

export const validate = <TState extends Dictionary<TState>>(
  value: TState[keyof TState],
  validation: Validate<TState, keyof TState>,
  formValues: TState,
) =>
  typeof validation === 'function'
    ? validation(value, formValues)
    : validation.value(value, formValues);
